import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { checkFeatureAccess } from '../../utils/helpers';
import LoadingPageText from '../common/Loading/LoadingPageText';

function convertIdToInt(props) {
  if (props && props.match && props.match.params && props.match.params.id) {
    return {
      ...props,
      match: {
        ...props.match,
        params: {
          ...props.match.params,
          id: parseInt(props.match.params.id, 10),
        },
      },
    };
  }
  return props;
}

const PrivateRoute = ({
  Component,
  Layout,
  path,
  featureAccess,
  exact,
  featureAccessList,
  isAuthenticated,
  isFetching,
  ...rest
}) => (
  <Route
    path={path}
    exact={exact}
    render={props => {
      if (isAuthenticated) {
        if (checkFeatureAccess(featureAccessList, featureAccess)) {
          return (
            <Layout>
              <Component {...rest} {...convertIdToInt(props)} />
            </Layout>
          );
        }
        if (isFetching) {
          return <LoadingPageText showHeader>Wait a moment while we gather profile info...</LoadingPageText>;
        }
        return <LoadingPageText showHeader>No feature access</LoadingPageText>;
      }
      return (
        <Redirect
          to={{
            pathname: '/SignIn',
            state: { from: { pathname: '/' } },
          }}
        />
      );
    }}
  />
);

PrivateRoute.defaultProps = {
  exact: false,
};

PrivateRoute.propTypes = {
  exact: PropTypes.bool,
  Component: PropTypes.func.isRequired,
  Layout: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  location: PropTypes.shape({
    hash: PropTypes.string,
    pathname: PropTypes.string,
    key: PropTypes.string,
    search: PropTypes.string,
    state: PropTypes.shape({
      from: PropTypes.shape({
        pathname: PropTypes.string,
      }),
    }),
  }),
  featureAccessList: PropTypes.arrayOf(PropTypes.string).isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  featureAccess: PropTypes.arrayOf(PropTypes.string).isRequired,
};

PrivateRoute.defaultProps = {
  location: {},
};

export default PrivateRoute;
